var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirect-to-mayday-web-button"},[_c('el-tooltip',{staticClass:"group-tooltip",attrs:{"content":_vm.$t('knowledge.actions.go-to-web'),"placement":"left"}},[_c('a',{staticClass:"icon-wrapper",attrs:{"href":_vm.redirectToWeb,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'external-link']}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }